<template>
  <div class='home' :class="{ 'paris': !isOct1Active }">
    <HeroImage
      :isHome='true'
      :isParisCampaign='!isOct1Active'
      :post='postCopy'
      alt='rise & shine'
      copy='JORNAY PM is taken at night and starts working as people rise, so they’re ready to shine with ADHD symptom support that lasts into the early evening.'
      subtitle='JORNAY PM is taken at night and starts working as people rise, so they’re ready to shine with ADHD symptom support that lasts into the early evening.'
      :image='activeHeroImage'
      :image__sm='activeMobileHeroImage'
    >
    </HeroImage>

    <JourneyParis v-if="!isOct1Active" />
    <Journey v-else />

    <PageNav :menus='activeNavItems' />

    <InfoBlockSticky />
    <InfoBlock class='trigger' />
    <Footer />
  </div>
</template>

<script>
import HeroImage from '../components/elements/HeroImage'
import Journey from '../components/sections/Journey'
import JourneyParis from '../components/sections/Journey-paris.vue'
import InfoBlock from '../components/sections/InfoBlock'
import InfoBlockSticky from '../components/sections/InfoBlockSticky'
import Footer from '../components/sections/Footer'
import heroImgSchool from '../assets/images/3_25/home/hero-school@2x.webp'
import mobileImgSchool from '../assets/images/3_25/home/hero-school_s@2x.webp'
import heroImgParis from '../assets/images/3_25/home/hero-paris@2x.webp'
import mobileImgParis from '../assets/images/3_25/home/hero-paris_s@2x.webp'
import ogImage from '../assets/images/Jornay_OG_Image.jpg'
import PageNav from '../components/elements/PageNav.vue'
import { releaseState } from '../utils/releaseManager'

export default {
  name: 'home',
  metaInfo: {
    title: 'Discover JORNAY PM® (methylphenidate HCI) for ADHD',
    link: [
      {
        rel: 'canonical',
        href: 'https://www.jornaypm.com/'
      }
    ],
    meta: [
      {
        name: 'description',
        content:
          'Learn about JORNAY PM® (methylphenidate HCI extended-release capsules), a prescription medication for treating ADHD in patients 6 years and older. Please see full Prescribing Information, including Boxed Warning, and Medication Guide'
      },
      {
        property: 'og:title',
        content: 'Discover JORNAY PM® (methylphenidate HCI) for ADHD'
      },
      {
        property: 'og:description',
        content:
          'Learn about JORNAY PM® (methylphenidate HCI extended-release capsules), a prescription medication for treating ADHD in patients 6 years and older. Please see full Prescribing Information, including Boxed Warning, and Medication Guide'
      },
      {
        property: 'og:image',
        content: ogImage
      },
      {
        property: 'google-site-verification',
        content: 'ARK4dFoz7A2muCj6LE7Z_Pf2IbIg41HtT0dLwNgni8I'
      }
    ]
  },
  components: {
    HeroImage,
    Journey,
    JourneyParis,
    InfoBlock,
    InfoBlockSticky,
    Footer,
    PageNav
  },
  data () {
    return {
      quizHeadings: [
        'Is ADHD affecting how your day starts?',
        'It\'s time to take the <b>Rate My Morning Quiz</b>, and talk to your doctor<br>because how the day starts is important.'
      ],
      heroImgSchool,
      mobileImgSchool,
      heroImgParis,
      mobileImgParis
    }
  },
  computed: {
    isOct1Active () {
      return releaseState.isOct1Active
    },
    activeHeroImage () {
      return this.isOct1Active ? this.heroImgSchool : this.heroImgParis
    },
    activeMobileHeroImage () {
      return this.isOct1Active ? this.mobileImgSchool : this.mobileImgParis
    },
    postCopy () {
      return this.isOct1Active
        ? 'from out of bed to <br class="d-none d-lg-block">the day ahead'
        : 'from out of bed to the day ahead, <br class="d-none d-lg-block">entrepreneur and ADHD advocate <br class="d-none d-lg-block">Paris Hilton rises and shines with <br class="d-none d-lg-block">JORNAY PM'
    },
    activeNavItems () {
      return this.isOct1Active
        ? [
            {
              title: 'Get the facts on JORNAY&nbsp;PM',
              routerLinkName: 'About',
              ctaText: 'START HERE'
            },
            {
              title: 'Find out if you can save',
              routerLinkName: 'Savings',
              ctaText: 'CHECK Here'
            }
          ]
        : [
            {
              title: 'Get the facts on JORNAY&nbsp;PM',
              routerLinkName: 'About',
              ctaText: 'START HERE'
            },
            {
              title: 'See how JORNAY PM works',
              routerLinkName: 'How',
              ctaText: 'LEARN MORE'
            }
          ]
    }
  },
  mounted () {
    if (location.hash.length) {
      const elementFaqId = '#quiz'
      const elementFaqItem = document.querySelector(elementFaqId)
      const elementFaqPositionTop = elementFaqItem.offsetTop
      window.scrollTo(0, elementFaqPositionTop)
    }
    if (sessionStorage.getItem('router')) {
      this.$router.push(sessionStorage.getItem('router'))
    }
  },
  destroyed () {
    sessionStorage.removeItem('router')
  }
}
</script>
